import { getOrCreateGlobalContext } from '@adsk/alloy-react-context';

import getPluginKey from './getPluginKey';
import { CommonReferencePickerPlugin } from '../types/ReferencePickerPlugin';

const REFERENCE_PICKER_CONTEXT_PREFIX = '__REFERENCE_PICKER_CONTEXT__';

export const getContextKey = (plugin: CommonReferencePickerPlugin) =>
  `${REFERENCE_PICKER_CONTEXT_PREFIX}${getPluginKey(plugin)}`;

export const getOrCreatePluginContext = (
  plugin: CommonReferencePickerPlugin,
) => {
  return getOrCreateGlobalContext(getContextKey(plugin));
};
